import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {environment} from '../../environments/environment';
import {catchError, delayWhen, map, retry, retryWhen, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OrderEntryService {

  constructor(private http: HttpClient) { }
  urlEndPoint = environment.endPoint;

  sendOrder(order: any): Observable<any> {
    return this.http.post(this.urlEndPoint + '/api/oe/order-insert', order ).pipe(
        map(val => {
          if (val === 0) {
            // error will be picked up by retryWhen
            throw val;
          }
          return val;
        })
        );
  }
  samplesCalculation(order: any): Observable<any> {
    return this.http.post(this.urlEndPoint + '/api/oe/samples-calculation', order );
  }

  createOrder(order: any): Observable<any> {
    return this.http.post(this.urlEndPoint + '/api/oe/create-order', order );
  }

  modifyOrder(order: any, profiles?): Observable<any> {
    //if(profiles) profiles.forEach( profile => order.addedTests.push(profile.value));
    return this.http.post(this.urlEndPoint + '/api/oe/modify-order', order );
  }

  samplesCalculationType1(order: any): Observable<any> {
    //if(profiles) profiles.forEach( profile => order.tests.push(profile.value));
    order.addedTests.forEach(test => order.oldTests.push(test))
    order.tests = order.oldTests;
    return this.http.post(this.urlEndPoint + '/api/oe/samples-calculation', order );
  }

  modifyOrderType1(order: any, profiles?): Observable<any> {

    if(order.deletedTests.length > 0 ){
      let tests2Delete = new Array();
      let tests = order.samples.map(sample => sample.tests).reduce((prev, next) =>prev.concat(next))
      order.deletedTests.forEach(
        test => {
          if( test.type == 'A')
            tests2Delete = tests2Delete.concat([test])
          else {
            tests2Delete = tests2Delete.concat(tests.filter( oldTest => oldTest.profileId == test.id))
          }
        }
      )

      order.deletedTests = tests2Delete;
      
    }
    return this.http.post(this.urlEndPoint + '/api/oe/modify-order-calculated', order );
  }

  saveOrder(order: any): Observable<any> {
    return this.http.post(this.urlEndPoint + '/api/oe/save-order', order ).pipe(
        catchError(this.handleError)
    );
  }

  getOrder(orderId: string, wardId: string): Observable<any> {
    const params = new URLSearchParams();
    params.set('id', orderId);
    params.set('wardId', wardId);
    return this.http.get<any>(this.urlEndPoint + '/api/oe/get-order?' + params.toString() )
        .pipe(
            retry(1),
            catchError(this.handleError)
        );
  }

  checkSamples(samples){
    const params = new URLSearchParams();
    params.set('samplesids', samples);
    return this.http.get(this.urlEndPoint + '/api/oe/check-samples?' + params.toString(), {responseType: 'text'});
  }

  getPriorityLevel(): Array<any> {
    return [{
      id: 0,
      name: 'Rutina',
      },
      {
        id: 3,
        name: 'Urgente'
      },
      {
        id: 4,
        name: 'Urgente spf'
      }
    ];
  }
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }


}
